import React from 'react'
import { useForm } from 'react-hook-form'
import {
  Button,
  FieldGroup,
  Header,
  Input,
  Label,
  Text,
  Dropdown,
  StateLabel,
  Fields,
} from '@pet-notify/ui'

import useDocumentTitle from 'hooks/document-title'
import type { OrderRedemptionInput } from 'services/order-redemtions'
import { canadianProvinces, countries, usStates } from '@pet-notify/data'

export type FormData = {
  address: string
  country: string
  address2: string
  city: string
  state: string
  zip: string
  phone: string
}

type Props = {
  onSubmit: (values: FormData) => void
  state: OrderRedemptionInput
}

function PremiumSignupShippingPage({ state, ...props }: Props) {
  useDocumentTitle('Shipping address | Pet Notify')
  const { handleSubmit, register, watch } = useForm<FormData>({
    defaultValues: state.shippingAddress || {
      country: 'US',
    },
  })
  const country = watch('country')

  const onSubmit = handleSubmit(props.onSubmit)

  return (
    <form onSubmit={onSubmit}>
      <Text variant='note' mb='2'>
        Step 3 of 4
      </Text>

      <Header mb='2'>Shipping address</Header>
      <Text mb='3'>
        Your Intellitag will arrive within 5-7 business days. Please allow 10-14
        business days for international orders.
      </Text>

      <Fields>
        <FieldGroup>
          <Label htmlFor='address-address'>Address</Label>
          <Input id='address-address' {...register('address')} />
        </FieldGroup>
        <FieldGroup>
          <Label htmlFor='address-address2'>Apartment / Suite</Label>
          <Input id='address-address2' {...register('address2')} />
        </FieldGroup>
        <FieldGroup>
          <Label htmlFor='address-city'>City</Label>
          <Input id='address-city' {...register('city')} />
        </FieldGroup>
        <FieldGroup>
          <Label htmlFor='address-country'>Country</Label>
          <Dropdown
            options={countries}
            id='address-country'
            {...register('country')}
          />
        </FieldGroup>
        <FieldGroup>
          <StateLabel htmlFor='address-state' country={country} />
          <Dropdown
            options={country === 'US' ? usStates : canadianProvinces}
            id='address-state'
            {...register('state')}
          />
        </FieldGroup>
        <FieldGroup>
          <Label htmlFor='address-zip'>
            {country === 'US' ? `Zip` : `Postal Code`}
          </Label>
          <Input type='text' id='address-zip' {...register('zip')} />
        </FieldGroup>
        <FieldGroup>
          <Label htmlFor='address-phone'>Mobile phone</Label>
          <Input type='phone' id='address-phone' {...register('phone')} />
        </FieldGroup>
      </Fields>

      <Button type='submit'>Continue</Button>
    </form>
  )
}

export default PremiumSignupShippingPage
